import React, { useEffect, useRef, useState } from "react";
import "datatables.net-dt";
import "datatables.net-responsive-dt";
import $ from "jquery";
import api from "../../../config/URL";
import toast from "react-hot-toast";
import TransactionView from "./TransactionView";

const Transaction = () => {
  const tableRef = useRef(null);
  const [datas, setDatas] = useState([]);
  const [percentage, setPercentage] = useState(0);
  const [loading, setLoading] = useState(false);
  const dataTableInstance = useRef(null);

  const initializeDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      return;
    }
    $(tableRef.current).DataTable({
      columnDefs: [{ orderable: false, targets: -1 }],
    });
  };

  useEffect(() => {
    if (!loading) {
      initializeDataTable();
    }
    return () => {
      destroyDataTable();
    };
  }, [loading]);

  const destroyDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
  };

  const refreshData = async () => {
    destroyDataTable();
    setLoading(true);
    try {
      const response = await api.get("/affiliate/affiliateTransaction");
      setDatas(response.data.data.orderItems);
      setPercentage(response.data.data.percentage);
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
    setLoading(false);
    initializeDataTable();
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (!loading && datas.length > 0) {
      if (dataTableInstance.current) {
        dataTableInstance.current.destroy();
      }
      dataTableInstance.current = $(tableRef.current).DataTable({
        destroy: true,
        responsive: true,
        autoWidth: false,
        columnDefs: [{ orderable: false, targets: -1 }],
      });
    }
  }, [loading, datas]);

  useEffect(() => {
    refreshData();
  }, []);

  return (
    <section className="px-4">
      <div className="card shadow border-0 mb-2 top-header">
        <div className="container-fluid py-1">
          <div className="row align-items-center">
            <div className="col p-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-3">
                  <h3 className="mb-0 ls-tight text-nowrap">Transaction </h3>
                  <p>({percentage}% commission applied to each order)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container card shadow border-0"
        style={{ minHeight: "80vh" }}
      >
        {loading ? (
          <div className="loader-container">
            <div className="loader">
              <svg viewBox="0 0 80 80">
                <circle cx="40" cy="40" r="32"></circle>
              </svg>
            </div>
          </div>
        ) : (
          <div className="table-responsive p-2">
            <table
              ref={tableRef}
              className="display table nowrap"
              style={{ width: "100%" }}
            >
              <thead className="thead-light">
                <tr>
                  <th scope="col" style={{ whiteSpace: "nowrap" }}>
                    S.NO
                  </th>
                  <th className="text-start">Order Number</th>
                  <th className="text-start">Product</th>
                  <th className="text-start">Grand Total</th>
                  <th className="text-start">Commission Earned</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {datas?.map((data, index) => (
                  <tr key={data.id}>
                    <td className="text-start align-middle">{index + 1}</td>
                    <td className="text-start align-middle">
                      {data?.item_number || "-"}
                    </td>
                    <td className="text-start align-middle">
                      {data?.product?.name || "-"}
                    </td>
                    <td className="text-start align-middle">
                      ₹{" "}
                      {data?.discount && data?.quantity
                        ? data?.discount * data?.quantity
                        : "-"}
                    </td>
                    <td className="text-start align-middle">
                      ₹ {data?.affiliate_commission || "-"}
                    </td>
                    <td className="align-middle text-center">
                      <TransactionView data={data} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default Transaction;
